module.exports = __webpack_public_path__ + "static/img/not-found-icon.d8511b83.svg";